import React, {Fragment, useContext, useState, useEffect, useRef} from "react";
import {InvitesContext} from "../context/InvitesContext";
import {fillInviteWithPlaceholders} from "../utils/InviteUtils";
import { Button } from '@material-ui/core';

const createIframe = ( inviteTemplateCode ) => {
    const srcAttribute = ( inviteTemplateCode ?
        `src="${process.env.REACT_APP_BACKEND_BASE_URL}/invitatie/${inviteTemplateCode}/1/ana-si-vlad?hidePicture=1"`
    : '' );

    return {
        __html: `<iframe id="invitePreview" ${srcAttribute} style="width:100%; height:100%; border: none;"></iframe>`
    };
}

export default function SideInvitePreview(props) {
    const iframeContainerRef = useRef(null);
    const invitesContext = useContext(InvitesContext);
    const [iframeState, setIframeState] = useState(createIframe(''));
    const style = {  width: '100%', height: '100%', background: '#fff' };
    const { showPreviewComponent, setShowPreviewComponent, classes } = props;

    useEffect( ()=>{
        if(invitesContext.state.invite.selectedInvite){
            setIframeState(createIframe(invitesContext.state.invite.selectedInvite));
        }
    }, [invitesContext.state.invite.selectedInvite])

    useEffect( ()=>{
        const iframe = document.getElementById("invitePreview");
        if(iframe.contentWindow){
            console.log(fillInviteWithPlaceholders(invitesContext.state.invite));
            iframe.contentWindow.postMessage(fillInviteWithPlaceholders(invitesContext.state.invite), '*');
        }
    }, [invitesContext.state.invite])

    return (
        <Fragment>
            {showPreviewComponent &&
                <Button className={`${classes.mobilePreviewBtn} ${classes.mobileClosePreviewBtn}`} variant="contained" onClick={() => {setShowPreviewComponent(false);}}>
                    Inchide
                </Button>
            }
            <div ref={iframeContainerRef} dangerouslySetInnerHTML={ iframeState } style={style}/>
        </Fragment>
    )
}